import React, { useEffect, useState } from 'react';
import {
  FormContainer,
  FormContent,
  FormHeadingContainer,
  FormHeading,
  FormCTAButtons,
  CTAButton,
  CompletionImage,
} from './FormCompletion.styled.js';
import { getStyleForProps } from '@/components/DesignSystem/ModernTheme/utils/getStylesConfig';
import { useSelector } from 'react-redux';

function TickMark(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="65"
      height="65"
      viewBox="0 0 65 65"
      fill="none"
    >
      <circle cx="32.5" cy="32.5" r="32.5" fill={props.bgColor || '#fff'} />
      <path
        d="M14.1162 33.4849L25.2778 44.6465L37.7526 32.1718L50.2273 19.697"
        stroke={props.color || '#333'}
        stroke-width="5.90909"
        stroke-linecap="round"
      />
    </svg>
  );
}
const FormCompletion = (props) => {
  const { widgetData, storeData } = useSelector((state) => ({
    widgetData: state.widgetsReducer,
    storeData: state.storeReducer.store,
  }));
  const [propStyle, setPropStyle] = useState(storeData?.theme?.style_template);

  useEffect(() => {
    if (widgetData?.activeStyleTemplate) {
      setPropStyle(getStyleForProps(widgetData?.activeStyleTemplate));
    } else {
      setPropStyle(getStyleForProps(storeData?.theme?.style_template));
    }
  }, [widgetData?.activeStyleTemplate, storeData?.theme?.style_template]);

  return (
    <FormContainer themeStyle={propStyle}>
      <FormContent>
        <FormHeadingContainer>
          <CompletionImage>
            <TickMark
              bgColor={propStyle?.buttonPrimary?.backgroundColor}
              color={propStyle?.buttonPrimary?.color}
            />
          </CompletionImage>
          <FormHeading textStyles={propStyle}>Completed Successfully</FormHeading>
        </FormHeadingContainer>
        <FormCTAButtons>
          <CTAButton themeStyles={propStyle} onClick={props.onClose}>
            Close
          </CTAButton>
        </FormCTAButtons>
      </FormContent>
    </FormContainer>
  );
};

export default FormCompletion;
